import { render, staticRenderFns } from "./filink.vue?vue&type=template&id=e012a640&"
import script from "./filink.vue?vue&type=script&lang=js&"
export * from "./filink.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/filink.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports